const LOGIN_STORAGE_KEY = 'LOGIN_USER';

export async function limparCacheDoSite(): Promise<void> {
  const loginBackup = localStorage.getItem(LOGIN_STORAGE_KEY);

  sessionStorage.clear();

  Object.keys(localStorage).forEach((key) => {
    if (key !== LOGIN_STORAGE_KEY) {
      localStorage.removeItem(key);
    }
  });

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }

  if (loginBackup) {
    localStorage.setItem(LOGIN_STORAGE_KEY, loginBackup);
  }

  const url = new URL(window.location.href);
  url.searchParams.set('_cache', Date.now().toString());
  window.location.replace(url.toString());
}
